export const ALBUM_SORTINGS = {
    playedRecently: "Played recently",
    addedRecently: "Added recently",
    alphabetical: "Alphabetical",
    creator: "Creator"
};

export const ALBUM_LAYOUTS = {
    list: "List",
    grid: "Grid"
};

export const ITEM_TYPES = {
    track: "track",
    album: "album",
    playlist: "playlist",
    artist: "artist",
    episode: "episode"
};

export const ALBUM_TYPES = {
    album: 'album',
    single: 'single',
    compilation: 'compilation'
};

export const ALBUM_TYPES_TEXTS = {
    album: 'LP',
    single: 'Single',
    compilation: 'Compilation'
};

export const REPEAT_MODES = {
    off: "off",
    context: "context",
    track: "track"
};

export const DEFAULT_REPEAT_MODE = REPEAT_MODES.off;

export const RANDOM_REPEAT_MODES = {
    off: "No repeat",
    queue: "Repeat queue",
    album: "Repeat album"
};

export const DEFAULT_RANDOM_REPEAT_MODE = RANDOM_REPEAT_MODES.off;